import { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ProseMirror } from "@progress/kendo-react-editor";
import {
  GetHtmlFromResourceFileComponent,
  GetResourceFileComponentFromHTML,
  ResourceFileComponent,
  resourceFileClassName,
} from "./ResourceFileComponentTool";
import { Button } from "@progress/kendo-react-buttons";
import ResourceFile from "../../../../optima_file/ResourceFile";

const { DOMParser: DOMParserObj, DOMSerializer: DOMSerializerObj } = ProseMirror;

export const ResourceFileComponentDialog = (props: any) => {
  const [items, setItems] = useState<ResourceFileComponent[] | undefined>(undefined);
  const [isNew, setIsNew] = useState(false);
  const { nodeAndPos, editorSchema } = props;

  // Read
  useEffect(() => {
    const serializer = DOMSerializerObj.fromSchema(editorSchema);
    const htmlDom = serializer!.serializeNode(nodeAndPos.node);
    let s = new XMLSerializer();
    let htmlContent = s.serializeToString(htmlDom);
    let tagIsNew = false;
    let resourceFileComponent: ResourceFileComponent[] = [];
    // New component
    if (
      !nodeAndPos.node.attrs?.class ||
      !nodeAndPos.node.attrs.class.split(" ").includes("str-component-" + resourceFileClassName)
    ) {
      if (nodeAndPos.node.type.isBlock) htmlContent = "";

      tagIsNew = true;
    } else {
      // Update component
      resourceFileComponent = GetResourceFileComponentFromHTML(htmlContent);
    }
    setItems(resourceFileComponent);
    setIsNew(tagIsNew);
  }, [nodeAndPos, editorSchema]);

  // Submit
  const submit = async () => {
    if (items === undefined) return;

    const domParser = new DOMParser();
    // Create a new DOM node from the HTML string
    const domNode = domParser.parseFromString(await GetHtmlFromResourceFileComponent(items), "text/html");
    // Create a new `DOMParser` instance with the schema
    const parser = DOMParserObj.fromSchema(editorSchema);
    // Parse the DOM node and create a ProseMirror node from it
    const newNode = parser.parse(domNode);
    props.onSubmit({ newNode, nodeAndPos });
  };

  // Delete
  const deleteClick = () => {
    props.onSubmit({ htmlContent: "", nodeAndPos });
  };

  return (
    <Dialog title={"Resursfiler"} onClose={props.onCancel} width="80vw" height="80vh">
      {items && <ResourceFile initialFiles={items} onChange={(files: ResourceFileComponent[]) => setItems(files)} />}
      <DialogActionsBar>
        <div style={{ textAlign: "right" }}>
          {!isNew && (
            <Button className="me-2" onClick={deleteClick}>
              Ta bort
            </Button>
          )}
          <Button themeColor={"primary"} onClick={submit} disabled={items?.length === 0} className="me-2">
            {isNew ? "Lägg till" : "Uppdatera"}
          </Button>
          <Button onClick={props.onCancel} themeColor={"secondary"}>
            Avbryt
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
